/* eslint-disable angular/controller-name, angular/controller-as */

angular.
module("digiexam").
controller("ViewClassController", function ViewClassController(
	$scope,
	$rootScope,
	$routeParams,
	$location,

	dxApi,
	dxDialog,
	dxExamsFilters,
	dxSearchSortOptions,
	course,
	ExamRepository,
	examStatus,
	group,
	dxLocalize,
	NodeRepository,
	dxSession
) {
	"use strict";

	$scope.dxSearchSortOptions = dxSearchSortOptions;

	$scope.class = {};
	$scope.loadClassWasSuccess = false;
	$scope.course = null;
	$scope.ExamRepository = ExamRepository;
	$scope.numNewStudents = 0;

	$scope.canEditClass = $routeParams.edit === "edit";
	$scope.canEditExams = typeof $routeParams.course !== "undefined";
	$scope.courseId = parseInt($routeParams.course, 10);
	$scope.groupId = parseInt($routeParams.id, 10);

	$scope.exams = {
		scheduled: [],
		ongoing: [],
		ungraded: [],
		graded: [],
		published: [],
	};

	$scope.errors = {
		exams: "",
	};

	NodeRepository.load(dxSession.getRole().organizationId).then(onNodeLoadSuccess);

	function onNodeLoadSuccess(node) {
		$scope.node = node;
	}

	function loadClassSuccess(response) {
		$scope.class = response;

		handleRedactedPiiStudents();
		$scope.loadClassWasSuccess = true;
	}

	function handleRedactedPiiStudents() {
		$scope.class.students.forEach(function foreachStudent(student) {
			if (student.redactedPii) {
				student.name = dxLocalize.get("RedactedPii.StudentName");
				student.code = "";
				student.email = "";
			}
		});
	}

	function loadClassError() {
		dxDialog.alert({
			title: dxLocalize.get("CouldNotFindClass"),
			body: dxLocalize.get("CouldNotFindClassYouSearchedFor"),
			acceptText: dxLocalize.get("Ok"),
		});
		$location.path($scope.Urls.get("groups"));
	}

	$scope.loadClass = function loadClass() {
		var getClassPromise = group.get($routeParams.id);
		getClassPromise.then(loadClassSuccess, loadClassError);
	};

	$scope.loadClass();

	function getExams(groupId, courseId) {
		dxApi.v1.exams.get(groupId, courseId).then(onGetExamsSuccess, onGetExamsError);
	}

	function onGetExamsSuccess(res) {
		var exams = res.data;
		$scope.exams.scheduled = exams.filter(dxExamsFilters.scheduledExamsFilter);
		$scope.exams.ongoing = exams.filter(dxExamsFilters.ongoingExamsFilter);
		$scope.exams.ungraded = exams.filter(dxExamsFilters.ungradedExamsFilter);
		$scope.exams.graded = exams.filter(dxExamsFilters.gradedExamsFilter);
		$scope.exams.published = exams.filter(dxExamsFilters.publishedExamsFilter);
	}

	function onGetExamsError() {
		$scope.errors.exams = dxLocalize.get("Error.LoadingExams");
	}

	if ($scope.canEditExams) {
		getExams($scope.groupId, $scope.courseId);

		var getCoursePromise = course.get($scope.courseId);
		getCoursePromise.then(function onGetCourse(response) {
			if (!response.faults) {
				$scope.course = response.course;
			}
		});
	}

	$scope.showEditClassNameDialog = function showEditClassNameDialog() {
		var scope = $rootScope.$new();

		scope.className = $scope.class.title;

		scope.canSubmit = function canSubmit() {
			return !(typeof scope.className === "undefined" || scope.className.length < 2);
		};

		scope.setNewClassName = function setNewClassName(name) {
			$scope.class.title = name;
			group.setTitle($scope.class.id, $scope.class.title);
			dxDialog.closeMostRecent();
		};

		scope.cancel = function cancel() {
			dxDialog.closeMostRecent();
		};

		dxDialog.show({
			templateUrl: "/partials/popups/edit-class-name.html",
			$scope: scope,
		});
	};

	$scope.studentCountString = function studentCountString() {
		if (!$scope.class.students) {
			return "";
		}

		var studentCount = $scope.class.students.length;

		switch (studentCount) {
			case 0:
				return dxLocalize.get("Student.None");
			case 1:
				return "1 " + dxLocalize.get("Student.Singular");
			default:
				return studentCount + " " + dxLocalize.get("Student.Plural");
		}
	};

	$scope.archiveClassString = function archiveClassString() {
		var s = dxLocalize.get("Archive") + " ";
		if ($scope.class.isArchived) {
			s = dxLocalize.get("Dearchive") + " ";
		}

		var g = dxLocalize.get("Group");
		var c = dxLocalize.get("Class");
		if (g && c) {
			g = g.toLowerCase();
			c = c.toLowerCase();
		}

		s += $scope.class.type === 0 ? g : c;
		return s;
	};

	$scope.showOrHideText = function showOrHideText(b) {
		return b ? dxLocalize.get("Hide") : dxLocalize.get("Show");
	};

	$scope.isArchiveButtonDisabled = function isArchiveButtonDisabled() {
		return !$scope.canEditClass;
	};

	$scope.showRemoveStudentConfirm = function showRemoveStudentConfirm(student) {
		var studentName = student.name + " (" + student.email + ")";
		dxDialog.confirm({
			title: dxLocalize.get("DoYouReallyWantToDoThis"),
			body: dxLocalize.get("Class.RemoveStudent", studentName, $scope.class.title),
			acceptText: dxLocalize.get("RemoveStudent"),
			acceptCallback: function acceptCallback() {
				$scope.removeStudent(student.id);
			},

			rejectText: dxLocalize.get("Cancel"),
		});
	};

	$scope.activeExamsFilter = function activeExamsFilter(e) {
		return e.examStatus === examStatus.ACTIVE && e.groupId === $scope.groupId && e.courseId === $scope.courseId;
	};

	$scope.ungradedExamsFilter = function ungradedExamsFilter(e) {
		return e.examStatus === examStatus.NOT_GRADED && e.groupId === $scope.groupId && e.courseId === $scope.courseId;
	};

	$scope.inactiveExamsFilter = function inactiveExamsFilter(e) {
		return e.examStatus === examStatus.NOT_STARTED && e.groupId === $scope.groupId && e.courseId === $scope.courseId;
	};

	$scope.gradedExamsFilter = function gradedExamsFilter(e) {
		return e.examStatus === examStatus.GRADED && e.groupId === $scope.groupId && e.courseId === $scope.courseId;
	};

	$scope.publishedExamsFilter = function publishedExamsFilter(e) {
		return e.examStatus === examStatus.PUBLISHED && e.groupId === $scope.groupId && e.courseId === $scope.courseId;
	};

	$scope.plannedExamsFilter = function plannedExamsFilter(e) {
		return e.examStatus === examStatus.PLANNED && e.groupId === $scope.groupId && e.courseId === $scope.courseId;
	};

	$scope.removeStudent = function removeStudent(studentId) {
		if (!$scope.canEditClass) {
			return;
		}

		var promise = group.deregisterStudent($scope.class.id, studentId);
		promise.then(function onDeregisterStudent(response) {
			if (!response.faults) {
				dxDialog.closeMostRecent();

				for (var i = 0; i < $scope.class.students.length; i++) {
					if ($scope.class.students[i].id === studentId) {
						$scope.class.students.splice(i, 1);
						break;
					}
				}
			}
		});
	};

	$scope.confirmArchive = function confirmArchive() {
		var title = "ArchiveClass";
		var body = "YouCanFindYourArchivedClassesInArchive";
		var button = "ArchiveClass";
		if ($scope.class.isArchived) {
			body = "ClassWillNowBeDearchived";
			title = "DearchiveClass";
			button = "DearchiveClass";
		}
		dxDialog.confirm({
			title: dxLocalize.get(title),
			body: dxLocalize.get(body),
			acceptText: dxLocalize.get(button),
			acceptCallback: $scope.toggleArchive,
			rejectText: dxLocalize.get("Cancel"),
		});
	};

	$scope.toggleArchive = function toggleArchive() {
		var promise = group.setArchived($scope.class.id, !$scope.class.isArchived);
		promise.then(function onArchived(response) {
			dxDialog.closeMostRecent();
			if (!response.faults) {
				$scope.class.isArchived = !$scope.class.isArchived;
			}
		});
	};
});
